import { verifyLinkedAccountRoute, router } from "@/router";

export function getLinkedAccountsUrl() {
	const { href } = router.buildLocation({
		to: verifyLinkedAccountRoute.to,
	});
	return `${window.location.origin}${href}`;
}
